import { Link } from "react-router-dom";
import { ChevronRight, Clock } from "lucide-react";
import { PrimaryCta } from "@/components/ui/PrimaryCta";
import { TextLink } from "@/components/ui/TextLink";
import { ReviewRemovalVisual } from "./ReviewRemovalVisual";

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-slate-50 via-white to-white dark:from-slate-900 dark:via-slate-950 dark:to-slate-950"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 -z-10 h-[480px] w-[900px] -translate-x-1/2 rounded-full bg-gradient-to-r from-teal-200/40 via-emerald-200/40 to-sky-200/40 blur-3xl"
      />

      <div className="max-w-6xl mx-auto px-6 pt-20 pb-20 grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
        <div className="min-w-0 lg:col-span-6">
          <Link
            to="/how-it-works"
            className="inline-flex items-center gap-2 text-sm font-medium text-emerald-700 hover:text-emerald-800 dark:text-emerald-400 dark:hover:text-emerald-300"
          >
            <span className="inline-flex h-5 items-center rounded-full bg-emerald-100 px-2 text-xs text-emerald-700 ring-1 ring-inset ring-emerald-200 dark:bg-emerald-900/50 dark:text-emerald-200 dark:ring-emerald-800">
              New
            </span>
            See how it works in 60 seconds
            <ChevronRight className="h-4 w-4" />
          </Link>

          <h1 className="mt-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight text-slate-900 dark:text-slate-100 leading-[1.05]">
            Continuous review protection for{" "}
            <span className="text-gradient-accent">your Amazon catalog.</span>
          </h1>

          <p className="mt-6 text-lg text-slate-600 dark:text-slate-400 max-w-xl">
            Reputely monitors every product, flags reviews that violate
            Amazon policy, generates appeal-ready takedown requests, and
            alerts your team before reputation issues compound.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <PrimaryCta href="/audit" size="lg">
              Get your free audit
            </PrimaryCta>
            <TextLink href="/how-it-works">How it works</TextLink>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-500 dark:text-slate-400">
            <span className="inline-flex items-center gap-1.5">
              <Clock className="h-4 w-4" /> Continuous monitoring
            </span>
            <span>Plans from $79/mo</span>
            <span>Unlimited appeal generation</span>
          </div>
        </div>

        <div className="min-w-0 lg:col-span-6">
          <ReviewRemovalVisual />
        </div>
      </div>
    </section>
  );
}
